var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-container",
      class: [_vm.drawerOpen ? "open" : "", !_vm.mobile ? "desktop" : ""]
    },
    [
      _c(
        "div",
        { staticClass: "sidebar-header", class: !_vm.mobile ? "desktop" : "" },
        [
          !_vm.mobile
            ? _c("div", { staticClass: "logo" }, [
                _c("img", { attrs: { src: _vm.logo, alt: "Footy Logo" } })
              ])
            : _c(
                "div",
                {
                  staticClass:
                    "tw-flex tw-flex-col tw-justify-center tw-items-start tw-w-full tw-h-full tw-cursor-pointer tw-pl-3",
                  on: { click: _vm.toggleDrawer }
                },
                [_c("v-icon", { attrs: { dark: "" } }, [_vm._v("mdi-menu")])],
                1
              )
        ]
      ),
      _c("div", { staticClass: "sidebar-body" }, [
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "leagues" ||
              _vm.route === "league" ||
              _vm.route === "new-league"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("leagues")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-format-list-numbered")])
              : _c("span", [_vm._v(" Leagues ")])
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "finals" ||
              _vm.route === "final" ||
              _vm.route === "new-finals" ||
              _vm.route === "new-addon-finals"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("finals")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-trophy")])
              : _c("span", [_vm._v(" Finals ")])
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "friendlies" || _vm.route === "friendly"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("friendlies")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-handshake")])
              : _c("span", [_vm._v(" Friendlies ")])
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "teams" || _vm.route === "team"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("teams")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-shield-star-outline")])
              : _c("span", [_vm._v(" Teams ")])
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "venues" || _vm.route === "venue"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("venues")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-soccer-field")])
              : _c("span", [_vm._v(" Venues ")])
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "referees" || _vm.route === "referee"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("referees")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-whistle")])
              : _c("span", [_vm._v(" Referees ")])
          ],
          1
        ),
        !_vm.mobile
          ? _c(
              "button",
              {
                staticClass: "nav-button",
                class: [
                  _vm.route === "coordinators" || _vm.route === "coordinator"
                    ? "active-route"
                    : "",
                  !_vm.mobile ? "desktop" : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.changeNav("coordinators")
                  }
                }
              },
              [
                _vm.mobile && !_vm.drawerOpen
                  ? _c("v-icon", [_vm._v("mdi-clipboard-list")])
                  : _c("span", [_vm._v(" Coordinators ")])
              ],
              1
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "nav-button",
            class: [
              _vm.route === "players" || _vm.route === "players"
                ? "active-route"
                : "",
              !_vm.mobile ? "desktop" : ""
            ],
            on: {
              click: function($event) {
                return _vm.changeNav("players")
              }
            }
          },
          [
            _vm.mobile && !_vm.drawerOpen
              ? _c("v-icon", [_vm._v("mdi-account-group")])
              : _c("span", [_vm._v(" Players ")])
          ],
          1
        ),
        !_vm.mobile
          ? _c(
              "button",
              {
                staticClass: "nav-button",
                class: [
                  _vm.route === "man-of-the-matches" ||
                  _vm.route === "man-of-the-matches"
                    ? "active-route"
                    : "",
                  !_vm.mobile ? "desktop" : ""
                ],
                staticStyle: {
                  "padding-left": "0rem !important",
                  "padding-right": "0rem !important"
                },
                on: {
                  click: function($event) {
                    return _vm.changeNav("man-of-the-matches")
                  }
                }
              },
              [
                _vm.mobile && !_vm.drawerOpen
                  ? _c("v-icon", [_vm._v("mdi-clipboard-list")])
                  : _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "white-space": "nowrap"
                        }
                      },
                      [_vm._v(" Player of the Match ")]
                    )
              ],
              1
            )
          : _vm._e(),
        !_vm.mobile
          ? _c(
              "button",
              {
                staticClass: "nav-button",
                class: [
                  _vm.route === "bookings" || _vm.route === "bookings"
                    ? "active-route"
                    : "",
                  !_vm.mobile ? "desktop" : ""
                ],
                staticStyle: {
                  "padding-left": "0rem !important",
                  "padding-right": "0rem !important"
                },
                on: {
                  click: function($event) {
                    return _vm.changeNav("bookings")
                  }
                }
              },
              [
                _vm.mobile && !_vm.drawerOpen
                  ? _c("v-icon", [_vm._v("mdi-clipboard-list")])
                  : _c("span", [_vm._v(" Booking ")])
              ],
              1
            )
          : _vm._e(),
        _vm.currentUser && !_vm.mobile && _vm.currentUser.role === "admin"
          ? _c(
              "button",
              {
                staticClass: "nav-button",
                class: [
                  _vm.route === "admin" ? "active-route" : "",
                  !_vm.mobile ? "desktop" : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.changeNav("admin")
                  }
                }
              },
              [
                _vm.mobile && !_vm.drawerOpen
                  ? _c("v-icon", [_vm._v("mdi-cog")])
                  : _c("span", [_vm._v(" Admin ")])
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }